var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{ref:"table",attrs:{"service":_vm.LogService,"entity":_vm.entity,"go-to-details-on-row-click":false,"columns":_vm.columns,"operations":"refresh"},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.name)+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }